import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  GET_REF_BOOKS,
  SEARCH_REF_BOOKS,
} from '@control-front-end/common/constants/refBooks';
import SelectEntityField from '../SelectEntityField';

const initState = {
  list: [],
  limit: 15,
  offset: 0,
  endList: false,
  reqStatus: 'success',
};

/**
 * Поиск справочников
 */
function SelectRefBook(props) {
  const dispatch = useDispatch();
  const [refBooks, setRefBooks] = useState(initState);

  const getData = (loadMore = false) => {
    const localState = loadMore ? refBooks : initState;
    dispatch({
      type: GET_REF_BOOKS.REQUEST,
      payload: { loadMore, localState },
      callback: (data) => setRefBooks(data),
    });
  };

  const clearData = () => {
    setRefBooks(initState);
  };

  /**
   * Обработка поискового запроса
   */
  const handleSearch = (query) => {
    if (!query.length) {
      getData();
      return;
    }
    if (query.length < 2) return;
    dispatch({
      type: SEARCH_REF_BOOKS.REQUEST,
      payload: { query },
      callback: (data) => setRefBooks({ ...initState, ...data }),
    });
  };

  return (
    <SelectEntityField
      objType="refBook"
      list={refBooks.list}
      onSearch={handleSearch}
      onFocus={() => getData()}
      onBlur={() => clearData()}
      onScroll={() => getData(true)}
      {...props}
    />
  );
}

export default SelectRefBook;
